import { Converter } from '../types/converter';

export const inductanceConverter: Converter = {
  id: 'inductance',
  name: 'Inductance Converter',
  icon: 'PlugZap',
  categories: ['electricity'],
  units: [
    // Base SI unit and prefixes
    { name: 'Henry', symbol: 'H', factor: 1 },
    { name: 'Exahenry', symbol: 'EH', factor: 1e18 },
    { name: 'Petahenry', symbol: 'PH', factor: 1e15 },
    { name: 'Terahenry', symbol: 'TH', factor: 1e12 },
    { name: 'Gigahenry', symbol: 'GH', factor: 1e9 },
    { name: 'Megahenry', symbol: 'MH', factor: 1e6 },
    { name: 'Kilohenry', symbol: 'kH', factor: 1e3 },
    { name: 'Hectohenry', symbol: 'hH', factor: 1e2 },
    { name: 'Dekahenry', symbol: 'daH', factor: 10 },
    { name: 'Decihenry', symbol: 'dH', factor: 0.1 },
    { name: 'Centihenry', symbol: 'cH', factor: 0.01 },
    { name: 'Millihenry', symbol: 'mH', factor: 1e-3 },
    { name: 'Microhenry', symbol: 'µH', factor: 1e-6 },
    { name: 'Nanohenry', symbol: 'nH', factor: 1e-9 },
    { name: 'Picohenry', symbol: 'pH', factor: 1e-12 },
    { name: 'Femtohenry', symbol: 'fH', factor: 1e-15 },
    { name: 'Attohenry', symbol: 'aH', factor: 1e-18 },
    
    // Alternative expressions
    { name: 'Weber/ampere', symbol: 'Wb/A', factor: 1 },
    
    // CGS units
    { name: 'Abhenry', symbol: 'abH', factor: 1e-9 },
    { name: 'EMU of inductance', symbol: 'EMU', factor: 1e-9 },
    { name: 'Stathenry', symbol: 'stH', factor: 8.987552e11 },
    { name: 'ESU of inductance', symbol: 'ESU', factor: 8.987552e11 }
  ]
};
